var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"article"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"container__article clear"},[(_vm.content)?_c('article-content',{attrs:{"data":_vm.content,"pageIndex":_vm.currentIndex}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4022676","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Article/index.vue
// module id = 1211
// module chunks = 1